import React from 'react';
import { IconButtonProps } from '@rjsf/utils';
import { KatButton, KatIcon } from '@amzn/katal-react';
import { AddButtonConstants } from '../../constants/ApplicationConstants';

/**
 * This button is responsible for adding a new array item in the react json schema.
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#addbutton
 * @returns KatalButton element.
 */
export const AddButton = ({
  uiSchema,
  registry,
  disabled,
  ...props
}: IconButtonProps) => {
  if (disabled) {
    return null;
  }

  const buttonText =
    uiSchema?.['items']?.['ui:placeholders']?.['ui:addButton']?.[
      'ui:addButtonText'
    ] ?? AddButtonConstants.ADD_BUTTON_TEXT;

  return (
    <KatButton
      size="small"
      variant="link"
      disabled={disabled}
      onClick={(e: any) => props.onClick!(e)}
    >
      <KatIcon size="small" slot="icon" name="add"></KatIcon>
      {buttonText}
    </KatButton>
  );
};
